import { lazy, Suspense } from "react";
import MostTunedSkeleton from "../skeleton/MostTunedSkeleton";

const RadioHomeCard = lazy(() => import("./RadioHomeCard"));

function RadioHomeCardSection({ channels, isLoadingMostTuned }: any) {
  return (
    <>
      {!isLoadingMostTuned && (
        <Suspense fallback={<MostTunedSkeleton />}>
          <div>
            <div className="flex justify-between max-sm:hidden">
              {channels &&
                channels?.map((value: any, i: number) => (
                  <RadioHomeCard data={value} key={i} />
                ))}
            </div>
            <div className="justify-between block sm:hidden">
              {channels && <RadioHomeCard data={channels && channels[0]} />}
            </div>
          </div>
        </Suspense>
      )}
      {isLoadingMostTuned && <MostTunedSkeleton />}
    </>
  );
}

export default RadioHomeCardSection;
